import type { PluginConfig as AkPluginTableConfig } from '@atlaskit/editor-plugin-table/types';

export const getTableOptions = (): AkPluginTableConfig => {
	return {
		allowBackgroundColor: true,
		allowColumnResizing: true,
		allowColumnSorting: true,
		allowDistributeColumns: true,
		allowHeaderColumn: true,
		allowHeaderRow: true,
		allowMergeCells: true,
		allowNumberColumn: true,
		allowControls: true,
		stickyHeaders: true,
		allowAddColumnWithCustomStep: false,
	};
};
